import React from 'react';
import { Card, Grid, InputAdornment } from '@material-ui/core';
import { css } from '@emotion/react';
import { isNumber } from 'lodash';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import { Body1, H1 } from './blocks';
import QboTagField from './QboTagField';

// Per-service flat-rate rows for the v2 (ONWARD_CONSOLIDATED) tariff. One row per service in the
// owner-shipper's catalog: Code + Description (read-only) and a flat Rate + QBO tag, persisted as
// SERVICE_RATE rate rows keyed by dimensions.code. A section-level sibling of Accessorials.jsx.
const ServicesSection = ({ serviceCatalog, rates, errors, callbacks, qbo_tags }) => {
    const serviceRates = rates?.SERVICE_RATE || [];

    return (
        <Card
            css={css`
                margin-bottom: 30px;
                padding: 24px;
                overflow: visible;
            `}
        >
            <Grid
                container
                css={css`
                    margin-bottom: 12px;
                `}
            >
                <H1>Services</H1>
            </Grid>
            {(serviceCatalog || []).length === 0 ? (
                <Body1>
                    No services in the catalog yet. Add services under SKU&apos;s / Services to set their rates here.
                </Body1>
            ) : (
                (serviceCatalog || []).map((svc) => {
                    const row = serviceRates.find((r) => r?.dimensions?.code === svc.service_code) || {};
                    return (
                        <Grid
                            key={svc.service_id}
                            container
                            css={css`
                                margin-bottom: 12px;
                                flex-wrap: nowrap;
                                align-items: center;
                            `}
                        >
                            <Grid
                                item
                                css={css`
                                    width: 200px;
                                    margin-right: 24px;
                                `}
                            >
                                <Body1>{svc.service_code}</Body1>
                            </Grid>
                            <Grid
                                item
                                css={css`
                                    width: 300px;
                                    margin-right: 24px;
                                `}
                            >
                                <Body1>{svc.description || ''}</Body1>
                            </Grid>
                            <Grid
                                item
                                css={css`
                                    margin-right: 24px;
                                `}
                            >
                                <CurrencyTextField
                                    size="small"
                                    value={isNumber(row.rate) ? row.rate : ''}
                                    error={!!errors?.missing?.[`SERVICE_RATE:${svc.service_code}`]}
                                    onChange={(_, val) => callbacks.setServiceRate({ code: svc.service_code, rate: val })}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                    }}
                                    css={css`
                                        width: 150px;
                                    `}
                                />
                            </Grid>
                            <Grid item>
                                <QboTagField
                                    options={qbo_tags}
                                    value={row.qbo_tag}
                                    onCommit={(qbo_tag) =>
                                        callbacks.setServiceRate({ code: svc.service_code, qbo_tag })
                                    }
                                    css={css`
                                        width: 200px;
                                    `}
                                />
                            </Grid>
                        </Grid>
                    );
                })
            )}
        </Card>
    );
};

export default ServicesSection;
